import { useSelector } from 'react-redux';
import { getUserPermissions } from 'store/permissions/selectors';
import { useCurrentUser } from 'store/users/selectors';

export const useHasPermission = (permissionKey) => {
    const currentUser = useCurrentUser();
    const userPermissions = useSelector(getUserPermissions);
    
    if (!currentUser || !currentUser.id) {
        return false;
    }

    if (currentUser.is_root === true) {
        return true;
    }

    const userPerms = userPermissions[currentUser.id];
    if (!userPerms || !userPerms.permissions) {
        return false;
    }

    const permissionValue = userPerms.permissions[permissionKey];
    return permissionValue === 'allow';
};

export const useHasAnyPermission = (permissionKeys) => {
    const currentUser = useCurrentUser();
    const userPermissions = useSelector(getUserPermissions);
    
    if (!currentUser || !currentUser.id) {
        return false;
    }

    if (currentUser.is_root === true) {
        return true;
    }

    const userPerms = userPermissions[currentUser.id];
    if (!userPerms || !userPerms.permissions) {
        return false;
    }

    return permissionKeys.some(key => userPerms.permissions[key] === 'allow');
};

export const useHasAllPermissions = (permissionKeys) => {
    const currentUser = useCurrentUser();
    const userPermissions = useSelector(getUserPermissions);
    
    if (!currentUser || !currentUser.id) {
        return false;
    }

    if (currentUser.is_root === true) {
        return true;
    }

    const userPerms = userPermissions[currentUser.id];
    if (!userPerms || !userPerms.permissions) {
        return false;
    }

    return permissionKeys.every(key => userPerms.permissions[key] === 'allow');
};

export const checkPermission = (userPermissions, userId, permissionKey, isRootUser) => {
    if (isRootUser) {
        return true;
    }

    if (!userPermissions || !userPermissions[userId] || !userPermissions[userId].permissions) {
        return false;
    }

    return userPermissions[userId].permissions[permissionKey] === 'allow';
};

export const checkAnyPermission = (userPermissions, userId, permissionKeys, isRootUser) => {
    if (isRootUser) {
        return true;
    }

    if (!userPermissions || !userPermissions[userId] || !userPermissions[userId].permissions) {
        return false;
    }

    return permissionKeys.some(key => userPermissions[userId].permissions[key] === 'allow');
};

